import { HttpErrorResponse } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export abstract class HandleResponseErrors {
  handlesResponse0: (httpErrorResponse: HttpErrorResponse) => void;
  handlesResponse401: (httpErrorResponse: HttpErrorResponse) => void;
  handlesResponse403: (httpErrorResponse: HttpErrorResponse) => void;
  handlesResponse500: (httpErrorResponse: HttpErrorResponse) => void;
  handlesDefaultError: (httpErrorResponse: HttpErrorResponse) => void;
}

export const HANDLE_RESPONSE_ERRORS_SERVICE = new InjectionToken<HandleResponseErrors>('HandleResponseErrorsService');
